import {
  AuthSelectors,
  FirebaseSelectors,
  LanguageSelectors,
  RemoteConfigService,
  useTranslation,
} from '@web_opxp/features';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { AppActions } from '../app';
import { DEFAULT_DAY0_BANNER } from '../base/constants';
import ENV from '../base/env';
import { Banner } from '../components/Banner';
import { IState } from '../store/state';
import './Day0Banner.scss';
import { getSecondsUntilDay0Expire, isDay0, parseTime } from './utils';

const Day0Coupon = 'D1DISC20CB';

export interface IDay0BannerProps {
  show: boolean;
  secondsLeft: number;
  showBannerExperiment: boolean;
  onBannerClick: (coupon?: string) => void;
}

export const Day0BannerFC: React.FC<IDay0BannerProps> = ({
  show,
  secondsLeft,
  showBannerExperiment,
  onBannerClick,
}) => {
  const { t } = useTranslation();
  const [timer, setTimer] = useState(secondsLeft);
  const [timeLeft, setTimeLeft] = useState('23:59:59');
  const timeout = useRef<any>();
  const decreaseTimer = () => {
    if (timer < 0) {
      // when timer goes below zero - stop it
      clearTimeout(timeout.current);
      timeout.current = 0;
      return;
    }
    setTimer(timer - 1);
  };
  // countdown effect
  useEffect(() => {
    if (!show) {
      return;
    }
    const timerId = setTimeout(decreaseTimer, 1000);
    timeout.current = timerId;
    return () => {
      if (!timeout.current) {
        // do not clear timeout if was already cleared
        return;
      }
      clearTimeout(timeout.current);
    };
  });
  // parsing seconds to timeleft string effect
  useEffect(() => setTimeLeft(parseTime(timer)), [timer]);

  // do not show banner when timer goes below zero
  if (!show || timer < 0) {
    return null;
  }
  // localize the title
  const title = t(`common:${showBannerExperiment ? 'Day0Banner_alternative' : 'Day0Banner'}.Title`, {
    timeLeft,
  });
  return (
    <Banner
      canClose={false}
      show={true}
      color="green"
      className="day0-banner"
      onClick={() => onBannerClick(Day0Coupon)}>
      <h3 className="large">{title}</h3>
    </Banner>
  );
};

export const mapStateToProps = (state: IState) => {
  const isPremium = AuthSelectors.isPremium(state);
  const created = AuthSelectors.getCreated(state);
  const isUserDay0 = isDay0(created);
  const localeLoaded = !LanguageSelectors.isLoading(state);
  const show = !isPremium && isUserDay0 && localeLoaded;
  const secondsLeft = getSecondsUntilDay0Expire(created);
  const isFirebaseReady = FirebaseSelectors.isReady(state);
  const day0BannerConfig = isFirebaseReady
    ? RemoteConfigService.getObjectConfigValue(ENV.RemoteConfigDay0Banner, DEFAULT_DAY0_BANNER)
    : undefined;
  const showBannerExperiment = !!day0BannerConfig?.banner_content;
  return {
    show,
    secondsLeft,
    showBannerExperiment,
  };
};

export const mapDispatchToProps = {
  onBannerClick: (coupon?: string) => {
    if (AppActions) return AppActions.redirectSubscribe(coupon);
  },
};

const Day0Banner = connect(mapStateToProps, mapDispatchToProps)(Day0BannerFC);
export default Day0Banner;
